import React, { Component } from 'react';
import { Image, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { incrementDownloads, getDownloads } from './../../components/firebaseQuerys';
import NotFound from './../../components/notFound';
import json from './librosData';

// https://www.paypal-community.com/t5/Products-and-Services/Paypal-me-link-with-specific-amount-not-working/td-p/2614777/page/4#
export default class infoLibro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cantidad: 1,
      downloadNum: null,
    };
    this.routeParam = this.props.match.params;
  }

  componentWillMount() {
    if (!json[this.routeParam.nombre]) return;
    getDownloads(`books/${this.routeParam.nombre}`).then((value) => {
      if (value.exists()) {
        this.setState({ downloadNum: value.val() });
      } else {
        this.setState({ downloadNum: 0 });
      }
    });
  }

  mas(e) {
    e.preventDefault();
    this.setState({ cantidad: this.state.cantidad + 1 });
  }

  menos(e) {
    e.preventDefault();
    this.setState({
      cantidad: this.state.cantidad === 1 ? 1 : this.state.cantidad - 1,
    });
  }

  increaseDownload() {
    // window.location.assign(json[this.routeParam.nombre].location);
    incrementDownloads(`books`, this.routeParam.nombre).then((result) => {
      if (result.committed) this.setState({ downloadNum: result.snapshot.val() });
    });
  }

  renderBuyOrFree() {
    // Paid books are bought through paypal.me; the book is sent once the payment is received.
    if (json[this.routeParam.nombre].precio > 0) {
      return (
        <Col xs={12} md={4}>
          <Row style={{ marginBottom: 30 }}>
            <Col xs={4}>
              <a onClick={this.menos.bind(this)}>
                <Image
                  src={require('./../../img/menos.png')}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  responsive
                />
              </a>
            </Col>
            <Col xs={4}>
              <p
                style={{
                  color: 'white',
                  fontSize: '18pt',
                  textAlign: 'center',
                  fontFamily: 'Source Sans Pro',
                }}
              >
                {this.state.cantidad}
              </p>
            </Col>
            <Col xs={4}>
              <a onClick={this.mas.bind(this)}>
                <Image
                  src={require('./../../img/mas.png')}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  responsive
                />
              </a>
            </Col>
          </Row>
          <p
            style={{
              color: 'white',
              fontSize: '18pt',
              textAlign: 'center',
              fontFamily: 'Source Sans Pro',
            }}
          >
            $ {this.state.cantidad * json[this.routeParam.nombre].precio} MXN
          </p>
          <a
            href={'https://paypal.me/RevistaAxon/' + this.state.cantidad * json[this.routeParam.nombre].precio + 'MXN'}
            target="_blank"
          >
            <Button bsClass="btn compraBtn" style={{ fontFamily: 'Source Sans Pro' }}>
              Comprar
            </Button>
          </a>
          <p
            className="envioLibro"
            style={{
              color: '#929292',
              fontSize: '12pt',
              textAlign: 'center',
              marginTop: 15,
              fontFamily: 'Source Sans Pro',
            }}
          >
            Una vez confirmado tu pago te enviaremos el libro. Dudas: editorialtyr@gmail.com
          </p>
          {/* <p
            style={{
              color: "#e4e400",
              fontSize: "16pt",
              marginTop: 30,
              fontFamily: "Source Sans Pro"
            }}
          >
            {`$ ${parseFloat(json[this.routeParam.nombre].precio).toFixed(
              2
            )} + Envío`}
            <br />
            {json[this.routeParam.nombre].precioElectronico &&
              `$ ${parseFloat(
                json[this.routeParam.nombre].precioElectronico
              ).toFixed(2)} Libro Electrónico`}
          </p> */}
        </Col>
      );
    }
    return (
      <Col xs={12} md={4}>
        {/* <a
          href={json[this.routeParam.nombre].location}
          target="_blank"
          download
          onClick={this.increaseDownload.bind(this)}
        >
        </a> */}
        <Link to={json[this.routeParam.nombre].location} target="_blank" onClick={this.increaseDownload.bind(this)}>
          <Button bsClass="btn compraBtn" style={{ fontFamily: 'Source Sans Pro' }}>
            Descargar
          </Button>
        </Link>
      </Col>
    );
  }
  render() {
    if (!json[this.routeParam.nombre]) return <NotFound />;
    return (
      <div className="navMargin" style={{ height: '100%' }}>
        <section
          style={{
            paddingTop: '2%',
            backgroundColor: '#352a35',
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            minHeight: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className="container">
            <Row>
              <Col
                xs={12}
                md={5}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Image
                  src={json[this.routeParam.nombre].img}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  responsive
                />
                <div style={{ height: 50 }} />
              </Col>
              <Col xs={12} md={7}>
                <p
                  style={{
                    color: 'white',
                    fontSize: '18pt',
                    fontWeight: 'bold',
                    fontFamily: 'Source Sans Pro',
                  }}
                >
                  {json[this.routeParam.nombre].titulo}
                </p>
                <p
                  style={{
                    color: '#929292',
                    fontSize: '16pt',
                    fontFamily: 'Source Sans Pro',
                  }}
                >
                  by {json[this.routeParam.nombre].profe}
                </p>
                <p
                  style={{
                    color: '#929292',
                    fontSize: '16pt',
                    fontFamily: 'Source Sans Pro',
                  }}
                >
                  {this.state.downloadNum !== null ? this.state.downloadNum : 0} número de descargas
                </p>
                <Row style={{ marginTop: 45 }}>
                  {this.renderBuyOrFree()}
                  <Col xs={12} md={8}>
                    <p
                      style={{
                        fontSize: '16pt',
                        color: 'white',
                        fontWeight: 'Bold',
                        fontFamily: 'Source Sans Pro',
                      }}
                    >
                      Descripción
                    </p>
                    <p
                      style={{
                        color: 'white',
                        fontSize: '14pt',
                        marginBottom: 30,
                        fontFamily: 'Source Sans Pro',
                      }}
                      dangerouslySetInnerHTML={{
                        __html: json[this.routeParam.nombre].desc,
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }

  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/libros/infoLibro.js